import { Box, Divider } from '@mui/material';
import type { ScanJob } from '@repo/api-gw-sdk';

import { PanelWrapper } from '@/components/panels/panelWrapper';
import { useFields } from '@/components/table/hooks';

import { FieldsSection } from './fieldsSection';
import { JobItemFields } from './jobItemFields';
import { JobStatusCard } from './jobStatusCard';
import { scanJobItemFields, sourceLocationFields } from './scanJobItemFields';

export const ScanJobsCard = ({
  job,
  onClose,
}: {
  job: ScanJob;
  onClose: () => void;
}) => {
  return (
    <PanelWrapper
      header={{
        title: 'Job details',
        onClose,
        hideBorder: true,
      }}
      testIdPrefix='scan-jobs-card'
    >
      <ScanJobsCardContent job={job} />
    </PanelWrapper>
  );
};

const ScanJobsCardContent = ({ job }: { job: ScanJob }) => {
  const formattedFields = useFields(sourceLocationFields, job);

  return (
    <Box className='pb-[40px]' overflow='auto'>
      <JobItemFields job={job} fields={scanJobItemFields} />
      <Divider />
      <JobStatusCard job={job} />
      <FieldsSection title='Source location' fields={formattedFields} />
    </Box>
  );
};
